<template>
    <div class="reader">
        <p class="info" v-show="!error">Lütfen ürünün <strong>QR kodunu</strong> okutunuz.</p>
        <p class="error" v-show="error">{{error}}</p>
        <div class="scanner">
            <i class="top-left-up"></i>
            <i class="top-left-side"></i>
            <i class="top-right-up"></i>
            <i class="top-right-side"></i>
            <i class="bottom-left-down"></i>
            <i class="bottom-left-side"></i>
            <i class="bottom-right-down"></i>
            <i class="bottom-right-side"></i>
            <qrcode-stream @decode="onDecode" @init="onInit" :camera="camera"></qrcode-stream>
        </div>
        <div class="popup" v-if="product">
            <div class="title">{{product.title}}</div>
            <div class="price"><span>{{product.price_title}}: </span><span class="bordered">{{product.price}}</span></div>
            <button class="rescan" @click="reScan">Tekrar tara</button>
        </div>
    </div>
</template>

<script>

    import axios from 'axios'
    import { QrcodeStream } from 'vue-qrcode-reader'

    export default {
        name: 'Reader',
        data() {
            return{
                error: null,
                camera: 'auto',
                product: null,
                language: 'tr',

            }
        },
        components:{
            QrcodeStream
        },
        methods:{
            reScan(){
                this.product = null;
                this.camera = 'auto';
                this.error = null;
            },
            onDecode(content) {
                this.camera = 'off';
                if(content){
                    let data = JSON.parse(content);
                    this.language = data.language;
                    axios.post(`${window.service}`, data).then((response)=>{
                        if(response.data.success){
                            // show popup
                            this.product = response.data.product;
                        }else{
                            this.error = "Kod okunamadı, tekrar deneyin.";
                            this.camera = "auto"
                        }
                    }).catch((error)=>{
                        this.error = "Kod okunamadı, tekrar deneyin.";
                        this.camera = "auto"
                    })
                }


                // get result from server
                // show popup
                // show rescan button in popup
            },
            async onInit (promise) {
                try {
                    await promise
                } catch (error) {
                    if (error.name === 'NotAllowedError') {
                        this.error = "Kameraya erişim izni vermelisiniz."
                    } else if (error.name === 'NotFoundError') {
                        this.error = "Bu cihazda bir kamera bulunamadı!"
                    } else if (error.name === 'NotSupportedError') {
                        this.error = "Güvenli bağlantı sağlanamadı!"
                    } else if (error.name === 'NotReadableError') {
                        this.error = "Kamerayı bir başka uygulama mı kullanıyor?"
                    } else if (error.name === 'OverconstrainedError') {
                        this.error = "Kamera kullanılabilir değil."
                    } else if (error.name === 'StreamApiNotSupportedError') {
                        this.error = "Tarayıcınız bu özelliği desteklemiyor."
                    } else if (error.name === 'InsecureContextError') {
                        this.error = "Güvenli bağlantı sağlanamadı!"
                    }
                }
            }
        }
    }
</script>



// WEBPACK FOOTER //
// themes/b2b/dev/js/qr/components/Reader.vue